export default __webpack_public_path__ + "static/media/mic.9410688e.svg";